export default __webpack_public_path__ + "static/media/special-cat-cn.4cac4271.webp";